module.exports = __webpack_public_path__ + "img/image2.2c042523.png";